'use client';
"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  EnvironmentProvider: function EnvironmentProvider() {
    return _EnvironmentProvider;
  },
  useEnvironment: function useEnvironment() {
    return _useEnvironment;
  }
});

module.exports = __toCommonJS(src_exports); // src/env.tsx

var import_react_use_safe_layout_effect = require("@chakra-ui/react-use-safe-layout-effect");

var import_react = require("react");

var import_jsx_runtime = require("react/jsx-runtime");

var EnvironmentContext = (0, import_react.createContext)({
  getDocument: function getDocument() {
    return document;
  },
  getWindow: function getWindow() {
    return window;
  }
});
EnvironmentContext.displayName = "EnvironmentContext";

function _useEnvironment() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      defer = _ref.defer;

  var _ref2 = (0, import_react.useReducer)(function (c) {
    return c + 1;
  }, 0),
      _ref3 = _slicedToArray(_ref2, 2),
      forceUpdate = _ref3[1];

  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(function () {
    if (!defer) return;
    forceUpdate();
  }, [defer]);
  return (0, import_react.useContext)(EnvironmentContext);
}

function _EnvironmentProvider(props) {
  var children = props.children,
      environmentProp = props.environment,
      disabled = props.disabled;
  var ref = (0, import_react.useRef)(null);
  var context = (0, import_react.useMemo)(function () {
    if (environmentProp) return environmentProp;
    return {
      getDocument: function getDocument() {
        var _a, _b;

        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
      },
      getWindow: function getWindow() {
        var _a, _b;

        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
      }
    };
  }, [environmentProp]);
  var showSpan = !disabled || !environmentProp;
  return /* @__PURE__ */(0, import_jsx_runtime.jsxs)(EnvironmentContext.Provider, {
    value: context,
    children: [children, showSpan && /* @__PURE__ */(0, import_jsx_runtime.jsx)("span", {
      id: "__chakra_env",
      hidden: true,
      ref: ref
    })]
  });
}

_EnvironmentProvider.displayName = "EnvironmentProvider"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  EnvironmentProvider: _EnvironmentProvider,
  useEnvironment: _useEnvironment
});